import { coerceProgress, coerceScope, DEFAULT_SCOPE, emptyProgress, type Progress } from '../../shared/progress'
import type { Profile, Settings } from './types'

/**
 * Локальная копия состояния. Источник истины — сервер, но игра должна
 * запускаться мгновенно и работать без сети, поэтому всё дублируется здесь.
 */
const KEY = 'multiplier.v1'

export const DEFAULT_SETTINGS: Settings = {
  scope: DEFAULT_SCOPE,
}

export const EMPTY_PROFILE: Profile = {
  firstName: '',
  lastName: '',
  age: null,
  avatarUrl: null,
}

interface Saved {
  settings: Settings
  profile: Profile
  progress: Progress
}

function coerceSettings(raw: unknown): Settings {
  const s = (raw ?? {}) as Partial<Settings>

  return { scope: coerceScope(s.scope) }
}

function coerceProfile(raw: unknown): Profile {
  const p = (raw ?? {}) as Partial<Profile>
  const name = (v: unknown): string => (typeof v === 'string' ? v.slice(0, 40) : '')
  const age =
    typeof p.age === 'number' && Number.isFinite(p.age) ? Math.min(18, Math.max(4, Math.round(p.age))) : null
  // Только ссылка: своя (/api/players/…) или внешняя из MAX.
  const avatarUrl =
    typeof p.avatarUrl === 'string' && /^(\/api\/|https:\/\/)/.test(p.avatarUrl) && p.avatarUrl.length <= 500
      ? p.avatarUrl
      : null

  return { firstName: name(p.firstName), lastName: name(p.lastName), age, avatarUrl }
}

const empty = (): Saved => ({
  settings: DEFAULT_SETTINGS,
  profile: EMPTY_PROFILE,
  progress: emptyProgress(),
})

export function load(): Saved {
  if (typeof localStorage === 'undefined') return empty()
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return empty()
    const parsed = JSON.parse(raw) as Partial<Saved>
    return {
      settings: coerceSettings(parsed.settings),
      profile: coerceProfile(parsed.profile),
      progress: coerceProgress(parsed.progress),
    }
  } catch {
    return empty()
  }
}

export function save(data: Saved): void {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.setItem(KEY, JSON.stringify(data))
  } catch {
    /* приватный режим / квота — локальная копия просто не сохранится */
  }
}

